import Csv from "../Csv/Csv";
import Imperial from "../Imperial/Imperial";
import TabSelectedKeyWrapper from "../TabSelectedKeyWrapper/TabSelectedKeyWrapper";
import ToggleNormalized from "../ToggleNormalized/ToggleNormalized";

import { SessionExtra } from "../../store/Session/SessionModel";

import "rc-segmented/assets/index.css";
import { GetNormalizedState } from "../../store/Session/helper/NormalizedValues";
import "./style.css";
import CsvClub from "../Csv/CsvClub";
interface Props {
	tabSelected: "ball-data" | "club-data" | "key-data";
	setSelectedTabFunc: any;
	sessionData: SessionExtra;
}

const TableTop = ({
	tabSelected,
	setSelectedTabFunc,
	sessionData,
}: Props): JSX.Element => {
	return (
		<div className="table-top">
			<TabSelectedKeyWrapper
				tabSelected={tabSelected}
				setSelectedTabFunc={setSelectedTabFunc}
			/>
			<div className="table-top-right">
				{sessionData.drillTargets && sessionData.drillTargets?.length > 0 ? (
					<Csv />
				) : (
					<CsvClub />
				)}
				<Imperial measuringSystem={sessionData.measuringSystem} />
				<ToggleNormalized
					isNormalized={sessionData.isNormalized}
					normalizedState={GetNormalizedState(sessionData)}
				/>
			</div>
		</div>
	);
};

export default TableTop;
